'use client';

import { useEffect } from 'react';
import { captureAffiliateSourceFromSearch } from '@/lib/marketing/affiliateSource';

/** Pamti `?aff=` / `?affiliate=` iz URL-a za kasnije slanje kontakt forme. */
export default function AffiliateSourceCapture() {
  useEffect(() => {
    captureAffiliateSourceFromSearch(window.location.search);
  }, []);

  return null;
}
